export function formatDateShort(d: string | null | undefined) {
	return d ? d.replaceAll('-', '. ') + '.' : ''
}
